module.exports = __webpack_public_path__ + "1236b7765b8c3096208402691e946feb.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-04-harrison-first-day-in-india/homestay-view.jpg
// module id = 565
// module chunks = 0